
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators/[slug]",
      function () {
        return require("private-next-pages/creators/[slug].tsx");
      }
    ]);
  